import * as yup from 'yup';

const DEFAULT_MESSAGE = 'Campo obrigatório'

export const PedidoDetalheSchema = yup.object().shape({
  finalidade: yup.object().shape({
    finalidade: yup.string().required(DEFAULT_MESSAGE),
  }),
  cadastro: yup.object().shape({
    cli_nome: yup.string().required(DEFAULT_MESSAGE),
    data_emissao: yup.string().required(DEFAULT_MESSAGE),
    grupo_tributario: yup.string().required(DEFAULT_MESSAGE),
  }),
  financeiro: yup.object().shape({
    data_referencia: yup.string().required(DEFAULT_MESSAGE),
    // [AJUSTE 07/08/2026] obrigatorio SO com o financeiro ligado.
    //
    // O select de condicao e desabilitado por "Gerar financeiro" desmarcado
    // (TabFinanceiro). Exigir o campo nesse estado e um beco sem saida: o usuario
    // nao consegue preencher o que o sistema cobra, e o erro aparece num campo
    // cinza na aba Financeiro enquanto o botao Salvar esta na ultima aba - a tela
    // simplesmente nao salva, sem dizer por que. Foi o que aconteceu com as vendas
    // geradas por Ordem de Servico, que nasciam com vnd_gerar_financeiro nulo.
    //
    // Sem financeiro nao ha parcelas a gerar, entao a condicao nao significa nada
    // ali - a PROC_VENDA_GRAVAR ja so chama a geracao quando @cpg_id IS NOT NULL.
    cpg_id: yup.string().when('gerar_financeiro', {
      is: (valor: any) => valor === true || valor === 'S' || valor === 'true',
      then: (schema) => schema.required(DEFAULT_MESSAGE),
      otherwise: (schema) => schema.nullable(),
    }),
    // [30/09] O credito utilizado TRAVA o Salvar - pedido do Deivid. Antes era so um
    // aviso vermelho no campo: ele informou R$ 56.451.213 com R$ 382,60 de saldo, viu o
    // aviso, e o pedido salvou.
    //
    // O teto e o MENOR entre o saldo do cliente e o valor do pedido (script 144 no
    // banco faz a mesma conta). credito_disponivel e gravado no formulario pela aba
    // Financeiro quando consulta a API; se a consulta falhou ele fica vazio e conta
    // como zero - trava por seguranca, em vez de liberar o que nao conseguiu conferir.
    valor_credito_utilizado: yup.number()
      .nullable()
      .transform((v, original) => (original === '' || original === null ? null : v))
      .test('credito-maximo', function (valor) {
        const credito = Number(valor ?? 0);
        if (!(credito > 0)) return true;

        const disponivel = Number(this.parent?.credito_disponivel ?? 0);
        // [30/09] Com o frete cobrado - o mesmo teto do banco (script 144).
        const pedido = Number(this.parent?.total_geral ?? 0)
          + Number(this.parent?.frete_cobrado ?? 0);
        const moeda = (n: number) =>
          n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        if (credito > disponivel + 0.004)
          return this.createError({
            message: `Crédito acima do disponível: o cliente tem ${moeda(disponivel)}`,
          });
        if (credito > pedido + 0.004)
          return this.createError({
            message: `Crédito acima do valor do pedido (${moeda(pedido)})`,
          });
        return true;
      }),
  }),
  // [AJUSTE 07/08/2026] as datas de locacao eram obrigatorias em TODA venda,
  // inclusive nas de finalidade "Normal", que nem tem aba de Locacao habilitada.
  //
  // Isso travava as vendas geradas por Ordem de Servico: elas nascem sem bloco de
  // locacao, a PROC_VENDA_LISTAR_UNICO devolve locacao = null (nao ha linha em
  // VENDALOCACAO), e o Salvar reprovava num campo que o usuario nao consegue nem
  // abrir - a aba fica cinza. Mesmo desenho do financeiro.cpg_id corrigido antes.
  //
  // `nullable()` aqui e o que faz o yup PULAR o shape quando locacao vem null.
  locacao: yup.object().nullable().shape({
    dataInicio: yup.string().nullable(),
    dataFim: yup.string()
      .nullable()
      .test(
        'is-greater',
        'A data final deve ser maior ou igual a inicial',
        function (value) {
          const { dataInicio } = this.parent;
          if (!dataInicio || !value) return true;
          const dataInicioDate = new Date(dataInicio);
          const dataFim = new Date(value);
          return dataFim >= dataInicioDate;
        }
      ),
  }),
})
  // As datas voltam a ser obrigatorias onde fazem sentido: venda de Locacao. O
  // teste fica na raiz porque precisa enxergar a finalidade, que e irma de
  // locacao - e o erro e devolvido no caminho do campo, para a aba marca-lo.
  .test(
    'locacao-datas-obrigatorias',
    DEFAULT_MESSAGE,
    function (values) {
      if (values?.finalidade?.finalidade !== 'Locação') return true;

      const faltando = ['dataInicio', 'dataFim'].filter(
        (campo) => !(values as any)?.locacao?.[campo]
      );
      if (faltando.length === 0) return true;

      return this.createError({
        path: `locacao.${faltando[0]}`,
        message: DEFAULT_MESSAGE,
      });
    }
  );
